import styled from 'styled-components';

const EmbedContainer = styled.span`
  display: flex !important;
  flex: 1 0 100%;

  iframe {
    display: block;
    margin: 0 auto;
  }
  @media (max-width: 632px) {
    iframe,
    object,
    embed {
      max-width: 440px;
      min-height: 100%;
    }
  }
  @media (max-width: 576px) {
    iframe {
      max-width: 100%;
    }
    object,
    embed {
      max-width: 100%;
      min-height: 240px;
      height: auto;
    }
  }
`;

export { EmbedContainer };
